define("static/js/newsContent",function(t,n){var i={init:function(){t(["static/js/alert"],function(t){t.alertObj.init()})}};n.contentObj=i});